<template>
    <div class="float-menu-wrap">
        <div class="fixed_back_top fixed" v-show="fixed_top" @click="back2top">
            <i class="icon icon-backtop"></i>
        </div>
        <div class="fixed_back_home fixed" v-if="!isInApp" @click="back2home">
            <i class="icon icon-home"></i>
        </div>
    </div>
</template>
<script>
import Util from '../_utils/util';
import Supporter from '../_utils/supporter.js';
export default {
    data(){
        return {
            fixed_top: false,
            fix_home: true,
            isInApp: Supporter.isMSOHU
        }
    },
    methods: {
        back2top(){
            window.scrollTo(0, 0);
        },
        back2home(){
            window.location.href = '//m.sohu.com';
        }
    },
    mounted(){
        var that = this;
        let heightTop;
        let showDistance = window.screen.availHeight * 2;
        window.addEventListener('scroll', Util.throttle(function(e){
            heightTop = document.documentElement.scrollTop || document.body.scrollTop;
            if(heightTop >= showDistance){
                that.fixed_top = true;
            }else{
                that.fixed_top = false;
            }
        }, 200));
    }
}
</script>
<style lang="less">
.float-menu-wrap {
        position: fixed;
        right: 15px;
        bottom: 60px;
        z-index: 888;    
        .fixed {
            position: relative;
            display: flex;
            width: 35px;
            height: 35px;
            margin-top: 7px;
            justify-content: center;
            align-items: center;
            color: #fff;
        }
        .fixed_back_top {
            background: rgba(255,244,220,.95);
            border: 1px solid rgba(252,228, 175, .5); /*no*/
            background-size: contain;
            .icon {
                font-size: 12px;/*no*/
                color: #fcca5b;
            }
        }
        .fixed_back_home {
            background: rgba(255,244,220,.95);
            border: 1px solid rgba(252,228, 175, .5); /*no*/
            background-size: contain;
            .icon {
                font-size: 20px;/*no*/
                color: #fcca5b;
                margin-top: -1px;
                margin-left: 1px;
            }
        }
    }
</style>





// WEBPACK FOOTER //
// src/components/FloatMenu.vue